"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntersectionObserver = require("react-intersection-observer");
var ViewSection = /*#__PURE__*/(0, _react.forwardRef)(function (props, forward) {
  var onInViewChange = props.onInViewChange;
  var _useInView = (0, _reactIntersectionObserver.useInView)({
      root: null
    }),
    intersectionRef = _useInView.ref,
    inView = _useInView.inView;
  var ref = (0, _react.useCallback)(function (node) {
    forward(node);
    intersectionRef(node);
  }, [intersectionRef, forward]);
  (0, _react.useEffect)(function () {
    onInViewChange(inView);
  }, [onInViewChange, inView]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    ref: ref
  }));
});
ViewSection.displayName = 'ViewSection';
var _default = ViewSection;
exports["default"] = _default;